import Prospects from './Pages/Prospects';

import { HiUserGroup } from 'react-icons/hi';
import { PiChatTeardropFill } from 'react-icons/pi';

let dashRoutes = [
  {
    path: '/prospects',
    name: 'Prospects',
    icon: <HiUserGroup color="inherit" />,
    component: Prospects,
  },
  {
    path: '/messages',
    name: 'Messages',
    icon: <PiChatTeardropFill color="inherit" />,
    component: Prospects,
  },
];

export default dashRoutes;
